var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3125 11.5938C8.3125 9.78157 9.78157 8.3125 11.5938 8.3125C13.4059 8.3125 14.875 9.78157 14.875 11.5938C14.875 12.5001 14.5088 13.3191 13.9139 13.9139C13.3191 14.5088 12.5001 14.875 11.5938 14.875C9.78157 14.875 8.3125 13.4059 8.3125 11.5938Z",
    fill: "#5063EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 0.8125C6.26903 0.8125 0.8125 6.26903 0.8125 13C0.8125 19.731 6.26903 25.1875 13 25.1875C19.731 25.1875 25.1875 19.731 25.1875 13C25.1875 6.26903 19.731 0.8125 13 0.8125ZM11.5938 6.4375C8.74603 6.4375 6.4375 8.74603 6.4375 11.5938C6.4375 14.4415 8.74603 16.75 11.5938 16.75C12.6785 16.75 13.6859 16.4143 14.5163 15.8422L17.0246 18.3504C17.3907 18.7165 17.9843 18.7165 18.3504 18.3504C18.7165 17.9843 18.7165 17.3907 18.3504 17.0246L15.8422 14.5163C16.4143 13.6859 16.75 12.6785 16.75 11.5938C16.75 8.74603 14.4415 6.4375 11.5938 6.4375Z",
    fill: "#5063EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.a3e4c6ec8a023893297a8702a3a636d0.svg";
export { ForwardRef as ReactComponent };